import { Pdc } from '@per-diem-calculator/vanilla';

const container = document.querySelector('#perDiemCalc');

new Pdc(container, {
    expense: {
        headingPrint: `Per Diem Report`,
        bodyPrint: `Generated by <a href="https://perdiemcalc.org">https://perdiemcalc.org</a>`,
    },
});
